
import React, { useState, useEffect } from "react";
import icoDownload from '../../assets/img/ico-download.svg';
import api from "../Services/api";
import "../../assets/css/dist/extrato-tac.dist.css"
import { PulseLoader } from 'halogenium';

const Filtro = () => {
    // const [nextPage, setNextPage] = useState(1);
    const [comunicados, setComunicados] = useState<any[]>([]);
    // const [counter, setCounter] = useState(1);
    // const [filtro, setFiltro] = useState<any[]>([]);
    const [notFound, setNotFound] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        api.get("/ObterTac")
            .then(response => {
                setComunicados(response.data.results);
            })
            .catch(error => {
                throw new Error(error);
            });
    }, []);

    const [form, setForm] = useState({
        procura: "",
        ano: "",
        plano: "",
        mes: "",

    });
    const handleChange = (event: any) => {
        let { name, value } = event.target;
        if (value === "Mês") {
            value = "";
        } if (value === "Ano") {
            value = "";
        }
        setForm({ ...form, [name]: value });
    };

    function handleSubmit(event: any) {
        event.preventDefault();
        if ((form.ano !== "" && form.mes === "") || (form.ano === "" && form.mes !== "")) {
            setError("* Preencha o campo de ano e mês");
            return false;
        } else {
            setError("");

        }

        var url = "";
        if (form.ano) {
            url += "Ano=" + form.ano + "&";
        }
        if (form.mes) {
            url += "Mes=" + form.mes + "&";
        }

        setComunicados([]);
        setLoading(true);

        api.get("/ObterTAC?" + url)
            .then(response => {

                if (response.data.results.length === 0) {
                    setNotFound(true);
                    setLoading(false);
                }
                else {
                    setNotFound(false);
                    setComunicados(response.data.results);

                    setLoading(false);
                }
            })
            .catch(error => {
                throw new Error(error);

            }
            );

    }

    const years = [];
    for (let i = 2010; i <= new Date().getFullYear(); i++) {
        years.push(i);
    }
    years.reverse();

    return (
        <>
            <div className="_the-content page-extrato pt-10 mb-8">
                <div className='container'>
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <h3 className="mb-5"> Filtro </h3>
                            <form className="_form">
                                <div className="row">
                                    <div className="col-7 col-md-4 mb-4">
                                        <label className="select" htmlFor="mes">
                                            <select defaultValue="" onChange={e => handleChange(e)} id="mes" name="mes" >
                                                <option value="">Mês</option>
                                                <option value="1">Janeiro</option>
                                                <option value="2">Fevereiro</option>
                                                <option value="3">Março</option>
                                                <option value="4">Abril</option>
                                                <option value="5">Maio</option>
                                                <option value="6">Junho</option>
                                                <option value="7">Julho</option>
                                                <option value="8">Agosto</option>
                                                <option value="9">Setembro</option>
                                                <option value="10">Outubro</option>
                                                <option value="11">Novembro</option>
                                                <option value="12">Dezembro</option>

                                            </select>
                                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.00072 5.17192L11.9507 0.221924L13.3647 1.63592L7.00072 7.99992L0.636719 1.63592L2.05072 0.221924L7.00072 5.17192Z" fill="#727272" />
                                            </svg>
                                        </label>
                                    </div>

                                    <div className="col-5 col-md-3">
                                        <label className="select" htmlFor="ano">
                                            <select defaultValue="" onChange={e => handleChange(e)} id="ano" name="ano">
                                                <option value="">Ano</option>
                                                {years?.map((year, index) => (
                                                    <option key={index} value={year}>{year}</option>
                                                ))}
                                            </select>
                                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.00072 5.17192L11.9507 0.221924L13.3647 1.63592L7.00072 7.99992L0.636719 1.63592L2.05072 0.221924L7.00072 5.17192Z" fill="#727272" />
                                            </svg>
                                        </label>
                                    </div>
                                    <div className="col-12 col-lg-2 col-xl-1">
                                        <button onClick={handleSubmit} type="submit" className="btn btn-filter icon rounded">
                                            <span className="d-lg-none mr-4">
                                                Buscar
                                            </span>
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M15 15L12 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </button>
                                    </div>

                                </div>
                                <span style={{
                                    fontWeight: 'bold',
                                    marginBlockStart: '10px',
                                    position: 'relative',
                                    left: '15px',
                                    color: 'rgb(232, 116, 0)',
                                }}>{error}</span>
                                <div className="row">
                                    <div className="col-12 col-md-7 mb-4 mb-lg-0">
                                        <label className="select" htmlFor="o-que-procura">
                                           
                                        </label>
                                    </div>
                                    

                                </div>
                            </form>


                            <div className="resultados">
                                <div className="row">
                                    {comunicados?.map((item, index) => (
                                        <div key={index} className="col-md-6">
                                            <a rel="noreferrer" href={item.URL} className="box-pdf mt-6 mb-4 d-block" target="_blank">
                                                <img src="../assets/img/organograma/img-org.png" alt="Organograma" className="mb-5" />

                                                <span> <strong> {item.Title}</strong> </span>   <br />
                                                <div className="card-comunicado__btn">
                                                    <a rel="noreferrer" href={item.URL} target="_blank" className="btn btn-primary rounded p-0 btn-100">
                                                        <img style={{ maxWidth: "55%" }} src={icoDownload} alt="Ícone" />
                                                    </a>

                                                </div>
                                                <span className="d-flex w-100 align-items-center my-4" >
                                           

                                                </span>
                                            </a>
                                        </div>

                                    ))}


                                </div>
                            </div>
                            {loading && <div className="container" id="loading" style={{ position: "relative", left: "35%" }}>
                                <div className="row justify-content-center">
                                    <div className="col-lg-10">
                                        <div className="tabs mb-6 pt-8">
                                            <div className='row align-items-strech'>

                                                <PulseLoader size={20} color="#E87400" margin="4px" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {notFound && <div className="container" id="notFound" style={{ position: "relative", left: "1%" }}>
                                <div className="row justify-content-center">
                                    <div className="col-lg-10">
                                        <div className="tabs mb-6 pt-8">
                                            <div className='row align-items-strech'>
                                                <h3>Oops! Não encontramos nada.</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};
export default Filtro;

